import React from "react";
import { Accordion, Col, Row } from "react-bootstrap";

const FAQSection = () => {
  return (
    <div className="faqsection">
      <Row className="faq_row">
        <Col lg={10} md={12}>
          <h1>FAQ</h1>
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                Which is the best diagnostic centre in Mohali?
              </Accordion.Header>
              <Accordion.Body>
                Kior Healthcare is a trusted diagnostic centre in Mohali known
                for advanced imaging technology, modern laboratory
                infrastructure, and accurate diagnostic reporting. We focus on
                quality diagnostics, patient comfort, and fast report delivery.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                Do you provide MRI, CT Scan, X-Ray, and Ultrasound at one
                centre?
              </Accordion.Header>
              <Accordion.Body>
                Yes. Kior Healthcare is an advanced diagnostic centre offering
                MRI, CT Scan, Digital X-Ray, Ultrasound, Mammography, and Colour
                Doppler along with complete pathology and blood testing services
                under one roof.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>
                How accurate are your diagnostic reports?
              </Accordion.Header>
              <Accordion.Body>
                We use advanced automated lab systems and modern imaging
                technology operated by experienced radiologists and lab experts
                to ensure highly accurate diagnostic reports.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header>
                Is Kior Healthcare serving areas near Chandigarh and Panchkula?
              </Accordion.Header>
              <Accordion.Body>
                Yes. We serve patients from Mohali, Chandigarh, Panchkula, and
                the entire Tricity region, making us a convenient diagnostic
                centre near Chandigarh and across Punjab.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5">
              <Accordion.Header>
                Is your diagnostic centre NABL certified?
              </Accordion.Header>
              <Accordion.Body>
                Kior Healthcare follows strict quality protocols and
                standardized testing processes to ensure accurate and reliable
                diagnostic reports aligned with NABL-level quality standards.
              </Accordion.Body>
            </Accordion.Item>
            {/* <Accordion.Item eventKey="6">
                <Accordion.Header>Lab Test At Home</Accordion.Header>
                <Accordion.Body>Agartala</Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="7">
                <Accordion.Header>Popular Tests</Accordion.Header>
                <Accordion.Body>Pregnancy Test</Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="8">
                <Accordion.Header>Lab Test At Home</Accordion.Header>
                <Accordion.Body>Agartala</Accordion.Body>
              </Accordion.Item> */}
          </Accordion>
        </Col>
      </Row>
    </div>
  );
};

export default FAQSection;
